import graphqlClient from '@/graphql/graphql-client';
import { eqFromWhere, organizationIdForQuery, toListQueryVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  OrgContractAnalysisByIdDocument,
  OrgContractAnalysisDocument,
  type OrgContractAnalysisQuery,
} from '@/graphql/generated/graphql';

export type ContractAnalysisItem = NonNullable<
  NonNullable<OrgContractAnalysisQuery['getOrgContractAnalysiss']>['items']
>[number];
export type GetOrgContractAnalysesResponse = OrgContractAnalysisQuery;

export const toContractAnalysesRequest = (
  params?: ListQueryVariables<Record<string, unknown>> | null
) => {
  const { where, paging } = toListQueryVariables(params);
  const itemId = eqFromWhere(where, 'ItemId');
  const organizationId = organizationIdForQuery(where);
  const pageNo = paging.pageNo;
  const pageSize = paging.pageSize;
  if (itemId) {
    return { document: OrgContractAnalysisByIdDocument, variables: { itemId, pageNo, pageSize } };
  }
  return {
    document: OrgContractAnalysisDocument,
    variables: { organizationId, pageNo, pageSize },
  };
};

export const useGetOrgContractAnalyses = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const request = toContractAnalysesRequest(params);
  return useQuery({
    queryKey: ['org-contract-analyses', request.variables],
    queryFn: () =>
      graphqlClient.request(request.document, request.variables),
  });
};

export const requestOrgContractAnalyses = (
  params?: ListQueryVariables<Record<string, unknown>> | null
) => {
  const request = toContractAnalysesRequest(params);
  return graphqlClient.request(request.document, request.variables);
};

export const GET_ORG_CONTRACT_ANALYSES_QUERY = OrgContractAnalysisDocument;
